export default __webpack_public_path__ + "static/media/graph-value-crypto.59177bda.png";